/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

export const clearElementSelection = () => {
  const selection = document.getSelection();
  if (selection?.anchorNode?.nodeType === 1) {
    selection.removeAllRanges();
  }
};

export const getIsSelectionPending = () => {
  const selection = document.getSelection();
  return (
    selection &&
    !(
      selection.type === 'None' ||
      (selection.anchorNode === selection.focusNode &&
        selection.anchorOffset === selection.focusOffset)
    )
  );
};
